const validateModel = async (model, doc, template) => {
  const res = {
    doc,
    errors: []
  };

  // doc matches the default template, verify that all properties match the given datatypes
  for (const field in template) {
    // check if the field is required
    let fieldData = template[field];
    if (fieldData.required) {
      if (!doc[field]) {
        res.errors.push(`Missing required field ${field} `);
      }

      if (typeof doc[field] !== fieldData.type) {
        res.errors.push(
          `field ${field} must be of type ${fieldData.type}.${typeof doc[field]} provided.`
        );
      }
    } else {
      // if the field is provided, verify that it's type is correct
      // if the default is null, omit it from the object
      if (fieldData.default !== null && typeof doc[field] === "undefined")
        doc[field] = doc[field] || fieldData.default;

      //verify that it matches the fields data type. if defaulted this should always be true
      if (fieldData.default !== null && typeof doc[field] !== fieldData.type) {
        res.errors.push(
          `field ${field} must be of type ${fieldData.type}.${typeof doc[field]} provided.`
        );
      }
    }

    // validate if field is required unique
    if (fieldData.unique) {
      // try getting the document where the field name is equal to the passed docs value
      const ref = model.where(field, "==", doc[field]).get();

      if (ref.exists) {
        res.errors.push(
          `'${field}'' must be a unique value. A document already exists with '${field} '' value '${doc[field]}'`
        );
      }
    }

    // if an enum was passed through, make sure the value passed is one of the accepted options
    if (
      fieldData.required &&
      fieldData.enums &&
      !fieldData.enums.includes(doc[field])
    ) {
      res.errors.push(
        `Error for field ${field}.Value ${
        doc[field]
        } does not match any of the expected parameters. [${
        fieldData.enums.join(
          ","
        )
        }]`
      );
    }
  }

  return res;
};

export default {
  validateModel
};
